import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import FunderSettings from './pages/FunderSettings';
import Admin from './pages/Admin';
import Merchants from './pages/Merchants';
import MerchantCreate from './pages/MerchantCreate';
import MerchantDetail from './pages/MerchantDetail';
import MerchantEdit from './pages/MerchantEdit';
import Deals from './pages/Deals';
import DealCreate from './pages/DealCreate';
import DealDetail from './pages/DealDetail';
import DealEdit from './pages/DealEdit';
import AuditLog from './pages/AuditLog';  // Phase 4b
import TeamManagement from './pages/TeamManagement';  // Phase 4c
import ISOs from './pages/ISOs';  // Phase 5b
import Funders from './pages/Funders';  // Phase 5b
import FunderCreate from './pages/FunderCreate';
import FunderDetail from './pages/FunderDetail';
import ContractTestRender from './pages/ContractTestRender';  // Phase 6B.4
import PDFAuthoringEditor from './components/PDFAuthoringEditor';  // Phase 7 - Template PDF Editor
import ContractOutputEditor from './components/ContractOutputEditor';  // Phase 7 - Contract Output Editor (new authoring model)
import AppLayout from './layouts/AppLayout';  // Phase 5a
import reportWebVitals from './reportWebVitals';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/signup" element={<Register />} />

        {/* Admin - outside shell */}
        <Route path="/admin" element={<PrivateRoute><Admin /></PrivateRoute>} />

        {/* Authenticated App Routes - wrapped in AppLayout */}
        <Route element={<PrivateRoute><AppLayout /></PrivateRoute>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/merchants" element={<Merchants />} />
          <Route path="/merchants/new" element={<MerchantCreate />} />
          <Route path="/merchants/:id/edit" element={<MerchantEdit />} />
          <Route path="/merchants/:id" element={<MerchantDetail />} />
          <Route path="/deals" element={<Deals />} />
          <Route path="/deals/new" element={<DealCreate />} />
          <Route path="/deals/:id" element={<DealDetail />} />
          <Route path="/deals/:id/edit" element={<DealEdit />} />
          <Route path="/deals/:dealId/contract-output-editor" element={<ContractOutputEditor />} />
          <Route path="/deals/:dealId/contract-output-editor/:exportId" element={<ContractOutputEditor />} />
          <Route path="/isos" element={<ISOs />} />
          <Route path="/funders" element={<Funders />} />
          <Route path="/funders/new" element={<FunderCreate />} />
          <Route path="/funders/:id" element={<FunderDetail />} />
          <Route path="/template-authoring/:templateId/:versionId" element={<PDFAuthoringEditor />} />
          <Route path="/app" element={<Navigate to="/deals/new" replace />} />
          <Route path="/settings/funder" element={<FunderSettings />} />
          <Route path="/audit-logs" element={<AuditLog />} />
          <Route path="/team" element={<TeamManagement />} />
          <Route path="/contracts/test-render" element={<ContractTestRender />} />
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
